/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { BatchOperationAdd, BatchOperationUpdate, IBlobInfo, IRListItem } from '@rhybus/api'
import { convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import React, { RefObject, forwardRef, useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { DUEOUT, DUEOUTS, PAGE_TITLE, ROUTE_TYPE } from '../../../Configuration'
import { sitePath } from '../../../assets/ts/api/api'
import { mpfRListsHttp } from '../../../assets/ts/api/mpf-r-lists-http'
import { COMPONENTS_CODE } from '../../../assets/ts/data/common-metadata'
import { deleteItem, transactionBatch } from '../../../assets/ts/data/data'
import {
  LIST_NAME as DueoutListName,
  DueOut as ServerDueoutType,
  addOrUpdateDueOut,
} from '../../../assets/ts/data/dueout/dueout'
import { LIST_NAME as DueOutHistoryList } from '../../../assets/ts/data/dueout/dueout-history'
import { Inquiry } from '../../../assets/ts/data/inquiry/inquiry'
import { STATUS_CODE } from '../../../assets/ts/data/inquiry/inquiry-status-metadata'
import { LIST_NAME as UserprofileListName } from '../../../assets/ts/data/user-profile'
import {
  formatBody,
  getMAJCOMCode,
  getUserProfileWithoutID,
  isChangeDetected,
  listAttachments,
  removeTags,
  scrollToTop,
  sendEmail,
} from '../../../assets/ts/general/general'
import { addToPIIAuditTrail, getPIIScanInfo, loadPII } from '../../../assets/ts/pii/pii'
import {
  isDODValid,
  isDropDownValid,
  isEmailValid,
  isInputValid,
  isPhoneNumberValid,
} from '../../../assets/ts/validations/validations'
import Alert from '../../../components/alert/alert'
import Buttons from '../../../components/buttons/buttons'
import DueoutsFormValidationMsgs from '../../../components/form-validation-msgs/dueouts-form-validation-msgs'
import Instructions from '../../../components/instructions/instructions'
import PageOverlayBusy from '../../../components/page-overlay/page-overlay-busy'
import SuccessMessage from '../../../components/popups/success-message'
import useDueoutHistory from '../../../hooks/dueout/use-dueout-history'
import useDueouts from '../../../hooks/dueout/use-dueouts'
import usePageTitle from '../../../hooks/use-page-title'
import PageHeader from '../../../layouts/header/page-header'
import { MetadataContext } from '../../../store/metadata-context-provider'
import { PreviousPageContext } from '../../../store/previous-page-provider'
import { RoleContext } from '../../../store/role-context-provider'
import {
  ACTIONS,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
  DUEOUTS_ACTIONS,
  DUEOUTS_STATUS,
  SELECT_LABEL,
} from '../../../utils/constants/global-constants'
import { PersonDetails } from '../../../utils/constants/global-interfaces'
import { CellPhoneProvider, PRP, Priority } from '../../../utils/controls/select-options-data'
import '../create.css'
import CreateActionBtns from '../create-action-btns'
import CustomerDetails from './customer-details'
import DueoutDetails from './dueout-details'

interface ValidationMsg {
  link: RefObject<null>
  title: string
}
interface BatchResult {
  Errors: any
  result: 'FAILED' | 'PASS'
  results: any
}
const WHEN_TO_CHECK_PII: 'first' | 'last' = 'last'

const DueoutForm = (props: any, ref: any) => {
  usePageTitle(PAGE_TITLE.CREATE_DUEOUT)
  const closeRef: any = null

  const { allMPF, initialInquiryAndDueoutFilter, isCPOwner, isLoading, isMPF } =
    useContext(RoleContext)
  const { majcoms, pascodeMetadata } = useContext(MetadataContext)
  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(false)
  const { guid } = useParams()
  const { dueouts, dueoutsAreLoading } = useDueouts({ dueoutGuid: guid, refresh: refresh }, !guid)
  const { dueOutHistory } = useDueoutHistory(
    { DueOutGUID: dueouts?.[0]?.DueOutGUID },
    !dueouts?.[0]?.DueOutGUID
  )
  console.log(dueOutHistory)
  const dodIdRef: RefObject<any> = useRef(null)
  const categoryRef: RefObject<null> = useRef(null)
  const descriptionRef: RefObject<null> = useRef(null)
  const dueDateRef: RefObject<null> = useRef(null)
  const priorityRef: RefObject<null> = useRef(null)
  const sectionRef: RefObject<null> = useRef(null)
  const titleRef: RefObject<null> = useRef(null)
  const dutyMailRef: RefObject<null> = useRef(null)
  const dutyPhoneRef: RefObject<null> = useRef(null)
  const locationRef: RefObject<null> = useRef(null)
  const organizationRef: RefObject<null> = useRef(null)
  const PASCODERef: RefObject<null> = useRef(null)
  const rankRef: RefObject<null> = useRef(null)
  const statusRef: RefObject<null> = useRef(null)
  const personalPhoneRef: RefObject<null> = useRef(null)
  const rntdRef: RefObject<null> = useRef(null)
  const pddRef: RefObject<null> = useRef(null)
  const dosRef: RefObject<null> = useRef(null)
  const prpRef: RefObject<null> = useRef(null)
  const personalMailRef: RefObject<null> = useRef(null)
  const popupBtnRef: RefObject<any> = useRef(null)

  const [existingFiles, setExistingFiles] = useState<any[]>([])
  const [files, setFiles] = useState<any[]>([])
  const [validationMsg, setValidationMsg] = useState<Array<ValidationMsg>>([])
  const [activeButton, setActiveButton] = useState<boolean>(true)
  const [displayAlert, setDisplayAlert] = useState(false)
  const [displayPII, setDisplayPII] = useState(false)
  const [show, setShow] = useState(false)
  const [showBottomSubmit, setShowBottomSubmit] = useState(false)
  const [showCloseAlert, setShowCloseAlert] = useState(false)
  const [showNoChanges, setShowNoChanges] = useState(false)
  const [showPageOverlay, setShowPageOverlay] = useState(false)
  const [showSaveSuccess, setShowSaveSuccess] = useState(false)
  const [showSubmitSuccess, setShowSubmitSuccess] = useState(false)
  const [showTopSubmit, setShowTopSubmit] = useState(false)
  const [showUpdateProfileAlert, setShowUpdateProfileAlert] = useState(false)
  const [unsupported, setUnsupported] = useState(false)
  const [unsupportedMsg, setUnsupportedMsg] = useState<string>('')

  const existingDueout: ServerDueoutType = dueouts[0] ?? undefined
  const [existCustomerDetails, setExistCustomerDetails] = useState<CustomerOrgDetails>()
  const [initialExistingDueout, setInitialExistingDueout] = useState<DueoutInputs>()

  const [alertMessage, setAlertMessage] = useState('')
  const [successType, setSuccessType] = useState('Submitted')

  const initialDueoutInput: DueoutInputs = {
    AssignedComponentCode: COMPONENTS_CODE.Regular_Air_Force,
    CategoryCode: ALL_SELECT_VALUE,
    CustomerId: '',
    CustomerStatus: ALL_SELECT_VALUE_STRING,
    DOS: '',
    Description: '',
    DoDNumber: '',
    DueDate: '',
    DutyEmail: '',
    DutyPhone: '',
    IsValidDutyEmail: false,
    IsValidLocation: true,
    IsValidOrganization: true,
    IsValidPASCODE: false,
    Location: '',
    OrgMAJCOM: '',
    Organization: '',
    PASCODE: '',
    PDD: '',
    PRP: 'No',
    PascodeID: -1,
    PersonalEmail: '',
    PersonalPhone: '',
    PersonalPhoneProvider: '',
    Priority: '',
    RNLTD: '',
    Rank: ALL_SELECT_VALUE_STRING,
    SectionCode: ALL_SELECT_VALUE,
    ServicingBy: '',
    ServicingMajcom: SELECT_LABEL,
    ServicingMajcomCode: ALL_SELECT_VALUE,
    ServicingOrganization: '',
    SubCategoryCode: ALL_SELECT_VALUE,
    Title: '',
  }

  const [actionBtnShowHide, setActionBtnShowHide] = useState({ close: false })
  const [dueoutInputs, setDueoutInputs] = useState<DueoutInputs>(initialDueoutInput)
  const [piiScan, setPIIScan] = useState({})
  const { currentPage, previousPage, setCurrentPage, setPreviousPage } =
    useContext(PreviousPageContext)
  const [uniqueChange, setUniqueChange] = useState<string>('')

  const validationFields: ValidationFields = {
    Category: {
      link: categoryRef,
      title: 'Category',
    },
    CurrentDate: {
      link: dueDateRef,
      title: 'Due Date should not less than the current Date',
    },
    DOS: {
      link: dosRef,
      title: 'DOS should not less than the current Date',
    },
    Description: {
      link: descriptionRef,
      title: 'Description',
    },
    DoDIDNumber: {
      link: dodIdRef,
      title: 'Enter valid DoD ID Number',
    },
    DueDate: {
      link: dueDateRef,
      title: 'Due Date',
    },
    DutyEmail: {
      link: dutyMailRef,
      title: 'Enter a Valid Duty Email',
    },
    DutyPhone: {
      link: dutyPhoneRef,
      title: 'Enter Duty Phone Number',
    },
    Location: {
      link: locationRef,
      title: ' Enter a Valid Assigned Location',
    },
    Organization: {
      link: organizationRef,
      title: ' Enter a Valid Organization',
    },
    PASCODE: {
      link: PASCODERef,
      title: ' Enter a Valid PASCODE',
    },
    PDD: {
      link: pddRef,
      title: 'PDD should not less than the current Date',
    },
    PRP: {
      link: prpRef,
      title: 'PRP should not less than the current Date',
    },
    PersonalMail: {
      link: personalMailRef,
      title: 'Enter Valid Mail',
    },
    PersonalPhone: {
      link: personalPhoneRef,
      title: 'Cell Phone Number',
    },
    Priority: {
      link: priorityRef,
      title: 'Priority',
    },
    RNTD: {
      link: rntdRef,
      title: 'RNTD should not less than the current Date',
    },
    Rank: {
      link: rankRef,
      title: 'Select a Valid Rank',
    },
    Section: {
      link: sectionRef,
      title: 'Section',
    },
    Status: {
      link: statusRef,

      title: 'Select a valid Status',
    },
    Title: {
      link: titleRef,
      title: 'Title',
    },
  }

  function buttonReferences(type: any) {
    if (type !== 'close') {
      closeRef?.current?.closeBtn()
    }
  }

  function getMAJCOMName(code: number): string {
    return (majcoms as any).find((item) => item.MAJCOMCode === code).Label
  }
  async function getFormBlobStorage() {
    const list = await mpfRListsHttp().getList(DueoutListName)
    const listBlobProvider = list.blobs()
    const listBlobInfos: IBlobInfo[] = await listBlobProvider.list(
      existingDueout.eKey as string,
      '/Customer'
    )
    if (listBlobInfos.length > 0) {
      setFiles(listBlobInfos)
      setExistingFiles(listBlobInfos)
    } else {
      setFiles([])
      setExistingFiles(listBlobInfos)
    }
  }

  const updateDueoutInput = (key: keyof DueoutInputs, value: number | string) => {
    setDueoutInputs((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  function generateCode(code: number) {
    return code > 0 || code === undefined ? code : null
  }

  function CurrentDateValidation(inputDate: Date): boolean {
    const currentDate = new Date()
    const yesterday = new Date(currentDate)
    yesterday.setDate(currentDate.getDate() - 1)
    return inputDate < yesterday
  }
  const handleInputValidation = (action?: string): boolean => {
    const isSavedAction = action === DUEOUTS_STATUS.SAVED

    const validArray: ValidationMsg[] = [
      !isDODValid(dueoutInputs.DoDNumber) ? validationFields.DoDIDNumber : undefined,
      !isDropDownValid(dueoutInputs.CustomerStatus) ? validationFields.Status : undefined,
      !isDropDownValid(dueoutInputs.Rank) ? validationFields.Rank : undefined,
      !isEmailValid(dueoutInputs.DutyEmail) ? validationFields.DutyEmail : undefined,
      !isPhoneNumberValid(dueoutInputs.DutyPhone) ? validationFields.DutyPhone : undefined,
      !isInputValid(dueoutInputs.PersonalPhone as string)
        ? undefined
        : !isPhoneNumberValid(dueoutInputs.PersonalPhone as string)
        ? validationFields.PersonalPhone
        : undefined,
      dueoutInputs.PersonalEmail === ''
        ? undefined
        : !isEmailValid(dueoutInputs.PersonalEmail as string)
        ? validationFields.PersonalMail
        : undefined,
      dueoutInputs.IsValidLocation ? undefined : validationFields.Location,
      dueoutInputs.IsValidOrganization ? undefined : validationFields.Organization,
      dueoutInputs.IsValidPASCODE ? undefined : validationFields.PASCODE,
      !isSavedAction && !isInputValid(dueoutInputs.Title) ? validationFields.Title : undefined,
      !isSavedAction && !isDropDownValid(dueoutInputs.SectionCode)
        ? validationFields.Section
        : undefined,
      !isSavedAction && !isDropDownValid(dueoutInputs.CategoryCode)
        ? validationFields.Category
        : undefined,
      !isSavedAction && !isDropDownValid(dueoutInputs.Priority)
        ? validationFields.Priority
        : undefined,
      !isSavedAction && !isInputValid(dueoutInputs.DueDate as string)
        ? validationFields.DueDate
        : undefined,
      !isSavedAction && CurrentDateValidation(new Date(dueoutInputs.DueDate))
        ? validationFields.CurrentDate
        : undefined,
      !isSavedAction && CurrentDateValidation(new Date(dueoutInputs.RNLTD))
        ? validationFields.RNTD
        : undefined,
      !isSavedAction && CurrentDateValidation(new Date(dueoutInputs.PDD))
        ? validationFields.PDD
        : undefined,
      !isSavedAction && CurrentDateValidation(new Date(dueoutInputs.DOS))
        ? validationFields.DOS
        : undefined,
      !isSavedAction &&
      !isInputValid(
        dueoutInputs.Description === ''
          ? ''
          : dueoutInputs.Description?.getCurrentContent()?.getPlainText().trim()
      )
        ? validationFields.Description
        : undefined,
    ].filter((item): item is ValidationMsg => !!item)
    setValidationMsg(validArray)

    return validArray.length > 0 || unsupported ? false : true
  }
  const validateLoginUser = () => {
    const validArray: ValidationMsg[] = [
      {
        link: dutyMailRef,
        title: 'You cannot create a Due Out for yourself. Please enter a different email',
      },
    ]
    setValidationMsg(validArray)
    setShowTopSubmit(true)
    setShowBottomSubmit(false)
    setDueoutInputs((prev) => ({
      ...prev,
      DutyEmail: '',
    }))
  }
  const findUserAssignedComponentWithOrg = (sevOrg: string[], metadata) => {
    const assComp = sevOrg.map((org) => {
      const componentCode = metadata.find(
        (e) => e.ServicingOrganization === org
      )?.AssignedComponentCode
      return componentCode
    })
    return assComp[0]
  }
  
  const isSupported = (assComp, pascode, servOrg) => {
    const creatorOrg =
      initialInquiryAndDueoutFilter.servicingOrganizationWithoutSectionFilter.length > 0
        ? initialInquiryAndDueoutFilter.servicingOrganizationWithoutSectionFilter
        : initialInquiryAndDueoutFilter.servicingOrganizationFilter

    const creatorComponent = findUserAssignedComponentWithOrg(creatorOrg, pascodeMetadata)
    if (!isCPOwner && creatorComponent && creatorComponent !== assComp) {
      setUnsupported(true)
      setUnsupportedMsg('You Cannot Save/Submit Due Out For A Users Assigned To Another Component.')
      return false
    } else if (!isCPOwner && creatorOrg.length && !creatorOrg.includes(servOrg)) {
      setUnsupported(true)
      setUnsupportedMsg('You Cannot Save/Submit Due Out For A Users Serviced By A Different MPF')
      return false
    } else if (
      initialInquiryAndDueoutFilter.cssPASCODES.length > 0 &&
      !initialInquiryAndDueoutFilter.cssPASCODES.includes(pascode)
    ) {
      setUnsupported(true)
      setUnsupportedMsg('Invalid PASCODE, Customer PASCODE must be Serviced by your CSS.')
      return false
    } else {
      setUnsupported(false)
      setUnsupportedMsg('')
      return true
    }
  }

  const handleUpdate = async (position: 'bottom' | 'top') => {
    saveOrSubmitDueout('update', position, WHEN_TO_CHECK_PII)
  }
  const onSaveAsDraft = async (position: 'bottom' | 'top') => {
    saveOrSubmitDueout(DUEOUTS_STATUS.SAVED, position, WHEN_TO_CHECK_PII)
  }
  const profileUpdate = async (button: string) => {
    setUniqueChange('')
    if (button === 'Yes') {
      setShowPageOverlay(true)
      const userDetails = mpfRListsHttp().me()
      const userId = (await userDetails).userId
      const userProfileObj = {
        AssignedComponentCode: dueoutInputs.AssignedComponentCode,
        DoDNumber: dueoutInputs.DoDNumber,
        DutyEmail: dueoutInputs.DutyEmail,
        DutyPhone: dueoutInputs.DutyPhone,
        IsArchived: false,
        ItemCreated: new Date(),
        ItemCreatedBy: userId,
        ItemModified: new Date(),
        ItemModifiedBy: userId,
        PascodeID: dueoutInputs.PascodeID,
        PersonalEmail: dueoutInputs.PersonalEmail,
        PersonalPhone: dueoutInputs.PersonalPhone,
        PersonalPhoneProvider: dueoutInputs.PersonalPhoneProvider,
        ProfileStatus: dueoutInputs.CustomerStatus,
        Rank: dueoutInputs.Rank,
        UserDisplayName: existCustomerDetails?.UserDisplayName,
        UserRID: existCustomerDetails?.UserRID,
      }
      if (existCustomerDetails && existCustomerDetails.eKey !== '') {
        userProfileObj['eKey'] = existCustomerDetails.eKey
        userProfileObj['eTag'] = existCustomerDetails.eTag
        userProfileObj['ItemCreated'] = new Date()
        userProfileObj['ItemCreatedBy'] = userId
      }

      try {
        const annList = await mpfRListsHttp().getList(UserprofileListName)
        const successful = await annList.addOrUpdateItem(userProfileObj as IRListItem)
        if (successType === 'Saved') {
          submitDueout(DUEOUTS_STATUS.SAVED)
        } else {
          submitDueout('')
        }
      } catch (error) {
        console.error(error)
      }
      setShowUpdateProfileAlert(false)
    } else {
      if (successType === 'Saved') {
        submitDueout(DUEOUTS_STATUS.SAVED)
      } else {
        submitDueout('')
      }
      setShowUpdateProfileAlert(false)
    }
  }

  const noChangesAlert = (button: string) => {
    setShowNoChanges(false)
  }

  const saveOrSubmitDueout = async (
    action?: string,
    position?: 'bottom' | 'top',
    checkPII: 'first' | 'last' = 'last'
  ): Promise<void> => {
    setShowPageOverlay(true)
    setSuccessType(
      action === 'update' ? 'Updated' : action === DUEOUTS_STATUS.SAVED ? 'Saved' : 'Submitted'
    )
    let changesDetected = true
    const isValid = await handleInputValidation(action)

    if (existingDueout) {
      const initialDueout = {
        ...initialExistingDueout,
        Description: removeTags(initialExistingDueout?.Description).trim().replace(/\n$/, ''),
      }
      const finalDueoutInput = {
        ...dueoutInputs,
        Description: dueoutInputs.Description?.getCurrentContent()?.getPlainText().trim(),
      }
      if (
        existingDueout.StatusCode !== STATUS_CODE.SAVED &&
        !isChangeDetected(initialDueout, finalDueoutInput) &&
        !isFilesChanged()
      ) {
        changesDetected = false
        setShowNoChanges(true)
        setShowPageOverlay(false)
      }
    }
    if (changesDetected) {
      if (checkPII === 'first') {
        const piiIsValid = await validateAndHandlePIISubmission(action, position)
        if (piiIsValid) {
          if (isValid) {
            const profileValidations = await userProfileChange()

            if (profileValidations.hasChanged) {
              setShowPageOverlay(false)
              setShowUpdateProfileAlert(true)
            } else {
              setShowPageOverlay(true)
              submitDueout(action)
            }
          } else if (!isValid && validationMsg.length > 0) {
            setShowPageOverlay(false)
            setShowTopSubmit(position === 'top')
            setShowBottomSubmit(position === 'bottom')

            if (position === 'top') scrollToTop()
            else {
              setTimeout(function () {
                popupBtnRef?.current?.scrollIntoView({ behavior: 'smooth' })
              }, 100)
            }
          }
        }
      } else if (checkPII === 'last') {
        /*NEEDS WORK 
        We're trying to mirror the functionality from the Inquiry-Form Page. 
        At the moment the issue is isValid is coming out false when we expect it to be true. 
        */

        if (isValid) {
          const piiIsValid = await validateAndHandlePIISubmission(action, position)
          if (piiIsValid) {
            const profileValidations = await userProfileChange()

            if (profileValidations.hasChanged) {
              setShowPageOverlay(false)
              setShowUpdateProfileAlert(true)
            } else {
              setShowPageOverlay(true)
              submitDueout(action)
            }
          } else {
            setShowPageOverlay(false)
            setShowTopSubmit(position === 'top')
            setShowBottomSubmit(position === 'bottom')

            if (position === 'top') scrollToTop()
            else {
              setTimeout(function () {
                popupBtnRef?.current?.scrollIntoView({ behavior: 'smooth' })
              }, 100)
            }
          }
        } else {
          setShowPageOverlay(false)
          setShowTopSubmit(position === 'top')
          setShowBottomSubmit(position === 'bottom')

          if (position === 'top') scrollToTop()
          else {
            setTimeout(function () {
              popupBtnRef?.current?.scrollIntoView({ behavior: 'smooth' })
            }, 100)
          }
        }
      }
    }
  }

  const userProfileChange = async () => {
    let hasChanged = false
    const isNewProfile = false
    const userProfileData: any =
      (await getUserProfileWithoutID(dueoutInputs.DoDNumber, 'DoDNumber')) || {}

    if (Object.values(userProfileData).length > 0) {
      let oldProfileData: Partial<Inquiry> = {}

      oldProfileData = {
        // ...dueoutInputs,
        AssignedComponentCode: userProfileData.AssignedComponentCode,
        CustomerStatus: userProfileData.CustomerStatus,
        DoDNumber: userProfileData.DoDNumber,
        DutyEmail: userProfileData.DutyEmail,
        DutyPhone: userProfileData.DutyPhone,
        Installation: userProfileData.Installation,
        OrgMAJCOM: userProfileData.OrgMAJCOM,
        Organization: userProfileData.Organization,
        PASCODE: userProfileData.PASCODE,
        PASCODEServicedBy: userProfileData.PASCODEServicedBy,
        PascodeID: userProfileData.PascodeID,
        Rank: userProfileData.Rank,
        ServicingMAJCOMCode: getMAJCOMCode(userProfileData.ServicingMAJCOM, majcoms),
        ServicingOrganization: userProfileData.ServicingOrganization,
      }
      const newProfileData = {
        AssignedComponentCode: dueoutInputs.AssignedComponentCode,
        CustomerStatus: dueoutInputs.CustomerStatus,
        DoDNumber: dueoutInputs.DoDNumber,
        DutyEmail: dueoutInputs.DutyEmail,
        DutyPhone: dueoutInputs.DutyPhone,
        Installation: dueoutInputs.Location,
        OrgMAJCOM: dueoutInputs.OrgMAJCOM,
        Organization: dueoutInputs.Organization,
        PASCODE: dueoutInputs.PASCODE,
        PASCODEServicedBy: dueoutInputs.ServicingBy,
        PascodeID: dueoutInputs.PascodeID,
        Rank: dueoutInputs.Rank,
        ServicingMAJCOMCode: dueoutInputs.ServicingMajcomCode,
        ServicingOrganization: dueoutInputs.ServicingOrganization,
      }

      Object.keys(newProfileData).forEach((key, i) => {
        if (
          String(newProfileData.DutyEmail.toLowerCase()) !==
          (oldProfileData.DutyEmail ?? '').toLowerCase()
        ) {
          hasChanged = true
        } else if (String(newProfileData[key]) !== String(oldProfileData[key])) {
          hasChanged = true
        }
      })
    }

    return { hasChanged, isNewProfile }
  }

  const submitDueout = async (action?: any): Promise<void> => {
    setActiveButton(false)
    setShowPageOverlay(true)
    const currentDate = new Date()
    const userDetails = await mpfRListsHttp().me()
    const userId = userDetails.userId

    const serverDueoutObject: ServerDueoutType = {
      AssignedComponentCode: dueoutInputs.AssignedComponentCode,
      CategoryCode: generateCode(dueoutInputs.CategoryCode as number),
      Customer: dueoutInputs.CustomerId,
      CustomerStatus: dueoutInputs.CustomerStatus,
      DOS: new Date(dueoutInputs.DOS),
      Description:
        dueoutInputs.Description === ''
          ? ''
          : draftToHtml(convertToRaw(dueoutInputs.Description.getCurrentContent())),
      DoDNumber: dueoutInputs.DoDNumber,

      DueDate: new Date(dueoutInputs.DueDate),
      DutyEmail: dueoutInputs.DutyEmail,
      DutyPhone: dueoutInputs.DutyPhone,
      FY: currentDate.getFullYear(),
      Installation: dueoutInputs.Location,
      ItemCreated: currentDate,
      ItemCreatedBy: userId,
      ItemModified: currentDate,
      ItemModifiedBy: userId,
      // Location: dueoutInputs.Location,
      OrgMAJCOM: dueoutInputs.OrgMAJCOM,
      Organization: dueoutInputs.Organization,
      PASCODE: dueoutInputs.PASCODE,
      PASCODEServicedBy: dueoutInputs.ServicingBy,
      PDD: new Date(dueoutInputs.PDD),
      PRP: dueoutInputs.PRP,
      PascodeID: generateCode(dueoutInputs.PascodeID),
      PersonalEmail: dueoutInputs.PersonalEmail,
      // PersonalPhone: dueoutInputs.PersonalPhone,
      PersonalPhoneNumber: dueoutInputs.PersonalPhone,
      PersonalPhoneProvider: dueoutInputs.PersonalPhoneProvider,
      PreviousCategoryCode: existingDueout
        ? existingDueout.CategoryCode
        : generateCode(dueoutInputs.CategoryCode as number),
      PreviousStatusCode:
        action === DUEOUTS_STATUS.SAVED
          ? DUEOUTS_STATUS.SAVED
          : existingDueout
          ? existingDueout.StatusCode
          : DUEOUTS_STATUS.NOT_STARTED,
      PreviousSubCategoryCode: existingDueout
        ? generateCode(existingDueout.SubCategoryCode as number)
        : generateCode(dueoutInputs.SubCategoryCode as number),
      Priority: dueoutInputs.Priority,
      RNLTD: new Date(dueoutInputs.RNLTD),
      Rank: dueoutInputs.Rank,
      SectionCode: generateCode(dueoutInputs.SectionCode as number),
      ServicingBy: isMPF && dueoutInputs.ServicingBy === 'CSS' ? 'MPF' : dueoutInputs.ServicingBy,
      ServicingMAJCOMCode: generateCode(dueoutInputs.ServicingMajcomCode as number),
      // ServicingMajcom: dueoutInputs.ServicingMajcom,
      // ServicingMajcomCode: dueoutInputs.ServicingMajcomCode,
      ServicingOrganization: dueoutInputs.ServicingOrganization,
      StatusCode:
        action === DUEOUTS_STATUS.SAVED ? DUEOUTS_STATUS.SAVED : DUEOUTS_STATUS.NOT_STARTED,
      SubCategoryCode: generateCode(dueoutInputs.SubCategoryCode as number),
      Subject: dueoutInputs.Title,
      // UserDisplayName: existCustomerDetails && existCustomerDetails.UserDisplayName,
      // UserRID: existCustomerDetails && existCustomerDetails.UserRID,
      eKey: existingDueout ? existingDueout.eKey : '',
      eTag: existingDueout ? existingDueout.eTag : '',
    }
    if (!existingDueout) {
      serverDueoutObject.DueOutGUID = crypto.randomUUID()
      serverDueoutObject.DueOutID = crypto.randomUUID()
    } else {
      serverDueoutObject.DueOutGUID = existingDueout.DueOutGUID
      serverDueoutObject.DueOutID = existingDueout.DueOutID
    }

    try {
      let addedDueout
      if (existingDueout) {
        addedDueout = serverDueoutObject
      } else {
        const initialAddedDueout = await addOrUpdateDueOut(serverDueoutObject)
        addedDueout = await addOrUpdateDueOut({
          DueOutID: generateID(serverDueoutObject.DoDNumber, initialAddedDueout.ID as number),
          eKey: initialAddedDueout.eKey,
          eTag: initialAddedDueout.eTag,
        })
      }
      const addHistoryObj = {
        ActionCode: ACTIONS.Submitted,
        DueOutGUID: addedDueout.DueOutGUID as string,
        DueOutID: addedDueout.DueOutID as string,
        IsArchived: false,
        ItemCreated: addedDueout.ItemCreated as Date,
        ItemCreatedBy: addedDueout.ItemCreatedBy as string,
        ItemModified: addedDueout.ItemModified as Date,
        ItemModifiedBy: addedDueout.ItemModifiedBy as string,
        PreviousStatusCode: addedDueout.PreviousStatusCode as string,
        SectionCode: addedDueout.SectionCode as number,
        ServicingBy: addedDueout.ServicingBy as string,
        StatusCode: addedDueout.StatusCode as string,
        UserRole: 'Customer',
        eKey: dueOutHistory.length > 0 ? dueOutHistory[0].eKey : '',
        eTag: dueOutHistory.length > 0 ? dueOutHistory[0].eTag : '',
      }

      let batchResult: BatchResult | null
      if (action === 'SAVED') {
        batchResult = await transactionBatch([
          { data: addedDueout, list: DueoutListName, op: BatchOperationUpdate },
        ])
      } else {
        batchResult = await transactionBatch([
          { data: addedDueout, list: DueoutListName, op: BatchOperationUpdate },
          {
            data: addHistoryObj,
            list: DueOutHistoryList,
            op:
              existingDueout && existingDueout.PreviousStatusCode !== 'SAVED'
                ? BatchOperationUpdate
                : BatchOperationAdd,
          },
        ])
      }
      if (batchResult.result === 'PASS') {
        setRefresh(!refresh)
        addToPIIAuditTrail(
          'CreateDueout',
          serverDueoutObject.DueOutGUID,
          piiScan,
          serverDueoutObject.DueOutID
        )
        // Handle file attachments and deletions
        if (existingDueout && isFilesChanged()) {
          const deletedFiles = existingFiles.filter(
            (aItem) => !files.some((bItem) => bItem.fileName === aItem.fileName)
          )

          const listName = await mpfRListsHttp().getList(DueoutListName)
          await Promise.all(
            deletedFiles.map((element) =>
              listName
                .blobs()
                .delete(
                  existingDueout.eKey as string,
                  element.fileName,
                  element.folderName,
                  element.eTag
                )
            )
          )
        }

        const promises: any = []
        if (files?.length > 0) {
          promises.push(
            listAttachments(DueoutListName, addedDueout.eKey, files.slice(0, 10), '/MPF/CSS')
          )
        }
        await Promise.all(promises)
        // Handle emails and success message
        if (action !== DUEOUTS_STATUS.SAVED) {
          await handleEmails(addedDueout, userId, action)
          setShowSaveSuccess(true)
          setTimeout(() => {
            setShowSaveSuccess(false)
            navigate(`${DUEOUTS}`) //ED0VFDZS, ED0VFWKF
          }, 1000)
        } else {
          setShowSaveSuccess(true)
          setTimeout(() => {
            setShowSaveSuccess(false)
            navigate(`${DUEOUT}/${addedDueout.DueOutGUID}`) //ED0VFDZS, ED0VFWKF
          }, 1000)
        }
      } else {
        deleteItem(DueoutListName, { eKey: addedDueout.eKey, eTag: addedDueout.eTag })
        setShowPageOverlay(false)
        console.error('batchResult', batchResult)
      }
    } catch (error) {
      handleError(error, 'Error submitting dueout')
    } finally {
      setShowTopSubmit(false)
      setShowBottomSubmit(false)
      setTimeout(() => {
        setShowPageOverlay(false)
      }, 1000)
    }
  }

  const handleEmails = async (data, userId, action) => {
    const navURL = sitePath + `/dueoutdetailview/${data.DueOutGUID}`
    let bodyText = ''
    let emailAction = ''

    switch (action) {
      case '':
        bodyText =  `A Due Out has been created for you and requires your attention.` 
        emailAction = 'SubmitDueOut'
      break
      case 'update':
        bodyText =  `A due out has been updated and requires your attention.` 
        emailAction = 'UpdateDueOut'
    }
    
    const emailBodyData = {
      ...data,
      bodyText: bodyText,
      isInquiry: false,
    }

    const body = formatBody(emailAction, emailBodyData, navURL)
    const to = data.Customer.userID || data.Customer

    const emailObjData = {
      ...data,
      Action: emailAction,
      ItemGUID: data.DueOutGUID,
      ItemID: data.DueOutID,
      Title: data.Subject,
    }

    const emails: Promise<any>[][] = []
    const subjectAction = action === 'update' ? 'is updated' : 'is created'

    if (to) {
      emails.push(
        sendEmail({
          bcc: '',
          body: body,
          bodySurvey: '',
          cc: '',
          data: emailObjData,
          isDiscussion: false,
          isSurvey: false,
          loginuserId: userId,
          navURL: navURL,
          subject: ` Due Out '${data.DueOutID}' ${subjectAction}`,
          to: to,
        })
      )
    }

    await Promise.all(emails)
  }

  function popupCloseOpenFunctionality(type: any, val: any) {
    setActionBtnShowHide({
      ...actionBtnShowHide,
      close: false,
    })
    if (type) {
      setActionBtnShowHide({ ...actionBtnShowHide, [type]: true })
      buttonReferences(type)
    }
    if (val === 'top') {
      setShowTopSubmit(!showTopSubmit)
    } else {
      setShowBottomSubmit(!showBottomSubmit)
    }
  }
  function isFilesChanged(): boolean {
    const filesSet = new Set(files.map((file) => (file.fileName ? file.fileName : file.name)))
    const existingFilesSet = new Set(existingFiles.map((file) => file.fileName))
    const hasDifferences =
      existingFiles.some((aItem) => !filesSet.has(aItem.fileName)) ||
      files.some((aItem) => !existingFilesSet.has(aItem.fileName))
    return hasDifferences
  }
  function generateID(DOD: string, id: number): string {
    return DOD + '-' + id.toString().padStart(7, '0')
  }
  const handleOpen = (): void => {
    setShow(!show) // Toggle accordion
  }
  const onClose = (): void => {
    setShowCloseAlert(true)
  }
  const closeFunction = (button: string): void => {
    if (button === 'OK') {
      if (currentPage === '') navigate(`${ROUTE_TYPE}`)
      else {
      navigate(previousPage, { state: { prevPath: '/myinquiries-dueouts' } })
      }
    }
    setShowCloseAlert(false)
  }

  function convertRTE(editorState): string {
    const editor = editorState.getCurrentContent()
    const convertedRTE = convertToRaw(editor)?.blocks?.map(({ text }) => text)
    const value = convertedRTE?.join(' ') || ''
    return value
  }
  /**validateAndHandlePIISubmission
   * Validates the PII (Personally Identifiable Information) for submission and handles the submission process.
   *
   * @param {string} action - The action being performed (e.g., 'submitted').
   * @param {string} position - The position to display PII compliance validation messages ('top' or 'bottom').
   * @returns {boolean} - Indicates whether the submission can proceed.
   */
  const validateAndHandlePIISubmission = async (action, position) => {
    let canSubmit = true

    const piiScanData = {
      Description: convertRTE(dueoutInputs?.Description), // Convert RTE (Rich Text Editor) content to plain text
      FileArray: Object.values(files), // Get an array of files
      Subject: dueoutInputs.Title, // Get the title from dueout inputs
    }
    try {
      const uploadData = await getPIIScanInfo(piiScanData, piiScan)
      if (action === 'submitted') {
        setPIIScan({ ...uploadData })
      }
      if (uploadData.canSubmit) {
        canSubmit = true
      } else {
        handlePIIValidationFailure(position)
        canSubmit = false
      }
    } catch (error) {
      console.error('PII validation failed:', error)
      canSubmit = false
    }
    return canSubmit
  }
  /**
   * Handles the display of PII compliance validation messages based on the specified position.
   *
   * @param {string} position - The position to display PII compliance validation messages ('top' or 'bottom').
   */
  const handlePIIValidationFailure = (position: 'bottom' | 'top'): void => {
    setShowTopSubmit(position === 'top')
    setShowBottomSubmit(position === 'bottom')
    setDisplayPII(true)
  }
  const handleError = (error, contextMessage) => {
    console.error(`${contextMessage}:`, error)
    setAlertMessage(`${contextMessage}: ${error.message}`) //this will be removed last validation is added
    setDisplayAlert(true)
  }
  useEffect(() => {
    const fetchAndSetDueoutDetails = async () => {
      if (existingDueout) {
        setShowPageOverlay(true)
        getFormBlobStorage()
        const existCustomerOrgDetails = {
          AssignedComponentCode: existingDueout.AssignedComponentCode,
          CustomerStatus: existingDueout.CustomerStatus,
          DoDNumber: existingDueout.DoDNumber,
          DutyEmail: existingDueout.DutyEmail,
          DutyPhone: existingDueout.DutyPhone,
          Location: existingDueout.Installation,
          OrgMAJCOM: existingDueout.OrgMAJCOM,
          Organization: existingDueout.Organization,
          PASCODE: existingDueout.PASCODE,
          PascodeID: existingDueout.PascodeID,
          PersonalEmail: existingDueout.PersonalEmail,
          PersonalPhone: existingDueout.PersonalPhoneNumber,
          PersonalPhoneProvider: existingDueout.PersonalPhoneProvider,
          Rank: existingDueout.Rank,
          ServicingBy: existingDueout.PASCODEServicedBy,
          ServicingMajcom: getMAJCOMName(existingDueout.ServicingMAJCOMCode),
          ServicingMajcomCode: existingDueout.ServicingMAJCOMCode,
          ServicingOrganization: existingDueout.ServicingOrganization,
        }
        const existingDueoutDetails = {
          CategoryCode: existingDueout.CategoryCode
            ? existingDueout.CategoryCode
            : ALL_SELECT_VALUE,
          CustomerId: (existingDueout.Customer as PersonDetails).userID
            ? (existingDueout.Customer as PersonDetails).userID
            : '',
          DOS: existingDueout.DOS
            ? new Date(existingDueout.DOS).toISOString().substring(0, 10)
            : '',
          Description: existingDueout.Description ? existingDueout.Description : '',
          DueDate: existingDueout.DueDate
            ? new Date(existingDueout.DueDate).toISOString().substring(0, 10)
            : '',
          IsValidDutyEmail: existingDueout ? true : false,
          IsValidLocation: existingDueout ? true : false,
          IsValidOrganization: existingDueout ? true : false,
          IsValidPASCODE: existingDueout ? true : false,
          PDD: existingDueout.PDD
            ? new Date(existingDueout.PDD).toISOString().substring(0, 10)
            : '',
          PRP: existingDueout.PRP ? existingDueout.PRP : '',
          Priority: existingDueout.Priority ? existingDueout.Priority : SELECT_LABEL,
          RNLTD: existingDueout.RNLTD
            ? new Date(existingDueout.RNLTD).toISOString().substring(0, 10)
            : '',
          SectionCode: existingDueout ? existingDueout.SectionCode : ALL_SELECT_VALUE,
          SubCategoryCode: existingDueout.SubCategoryCode
            ? existingDueout.SubCategoryCode
            : ALL_SELECT_VALUE,
          Title: existingDueout.Subject ? existingDueout.Subject : '',
          eKey: existingDueout.eKey ? existingDueout.eKey : '',
          eTag: existingDueout.eTag ? existingDueout.eTag : '',
        }
        setDueoutInputs((prev) => ({
          ...prev,
          ...existCustomerOrgDetails,
          ...existingDueoutDetails,
        }))
        setInitialExistingDueout({
          ...existCustomerOrgDetails,
          ...existingDueoutDetails,
        })
        const loginDetails: any =
          (await getUserProfileWithoutID(existingDueout.DutyEmail, 'DutyEmail')) || {}
        setExistCustomerDetails({
          ...existCustomerOrgDetails,
          UserDisplayName: loginDetails?.UserDisplayName,
          UserRID: loginDetails?.UserRID,
          eKey: loginDetails?.eKey,
          eTag: loginDetails?.eTag,
        })
        setTimeout(() => {
          setShowPageOverlay(false)
        }, 1000)
      } else {
        setDueoutInputs(initialDueoutInput)
        setExistCustomerDetails(undefined)
        setFiles([])
      }
    }
    fetchAndSetDueoutDetails()
  }, [existingDueout, refresh])

  useEffect(() => {
    loadPII()
  }, [])

  useEffect(() => {
    setDisplayPII(false)
    if (Object.keys(piiScan).length > 0) {
      Object.keys(piiScan).forEach((key) => {
        if (key === 'FileArray') {
          for (const file of piiScan[key].value) {
            if (file.resultsArray.length > 0 && !file.userAnswer) {
              setDisplayPII(true)
            }
          }
        } else {
          if (piiScan[key].resultsArray.length > 0 && !piiScan[key].userAnswer) {
            setDisplayPII(true)
          }
        }
      })
    }
  }, [piiScan])

  useEffect(() => {
    if (displayPII === false && validationMsg.length === 0) {
      setShowTopSubmit(false)
      setShowBottomSubmit(false)
    }
  }, [displayPII])

  if (!isLoading) {
    if (!allMPF) {
      navigate('/accessdenied')
    }
  }

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (location && currentPage && currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes

  return (
    <>
      <div id='scroll'></div>
      <PageHeader
        extras={
          <CreateActionBtns
            activeButton={activeButton}
            handleSaveOrSubmit={() => saveOrSubmitDueout('', 'top', WHEN_TO_CHECK_PII)}
            handleUpdate={() => handleUpdate('top')}
            isEditDueout={
              existingDueout && existingDueout.StatusCode !== DUEOUTS_STATUS.SAVED ? true : false
            }
            onClose={onClose}
            onSaveAsDraft={() => onSaveAsDraft('top')}
            onSubmit={(event) => {
              event?.preventDefault()
            }}
            showSubmit={showTopSubmit}
            type={'button'}
          />
        }
        icon='icon-create font-16 me-1 color-primary'
        id={'create-inquiry'}
        name='Create Due Out'
        toolTip={
          <Buttons
            className='mx-2 btn-sm d-flex align-items-center whitetext bgcolor-22 btn-border-radius1 sourcesanspro font-13'
            label='Instructions'
            onClick={handleOpen}
            rIcon={show ? 'icon-arrow-down ms-1 font-12 rotate' : 'icon-arrow-down ms-1 font-12'}
            type='button'
          />
        }
      />
      <div className='container'>
        <div className=' mt-3'>
          <div>{show && <Instructions />}</div>
          <div>
            {showTopSubmit && validationMsg.length > 0 && (
              <div>
                <DueoutsFormValidationMsgs
                  displayPII={displayPII}
                  inputValidationObj={validationMsg}
                  piiScan={piiScan}
                  popupCloseOpenFunctionality={popupCloseOpenFunctionality}
                  ref={closeRef}
                  setPIIScan={setPIIScan}
                  updateClickPosition='top'
                  validationref={popupBtnRef}
                />
              </div>
            )}
          </div>
          <div className='whitebg border-radius dueoutfeilds '>
            <div className='p-3'>
              {unsupported && (
                <div className='invalidmsg bordered11 p-2 bgcolor-35 my-2 border-radius poppins-medium font-12 title-color '>
                  <span className='invalidicon'>
                    <p>!</p>
                  </span>
                  {unsupportedMsg}
                </div>
              )}
              <CustomerDetails
                CellPhoneProvider={CellPhoneProvider}
                dueoutInputs={dueoutInputs}
                existCustomerDetails={existCustomerDetails}
                existingDueout={existingDueout}
                initialDueoutInput={initialDueoutInput}
                isSupported={isSupported}
                setDueoutInputs={setDueoutInputs}
                setExistCustomerDetails={setExistCustomerDetails}
                setUniqueChange={setUniqueChange}
                updateDueoutInput={updateDueoutInput}
                validateLoginUser={validateLoginUser}
                validationFields={validationFields}
              />
              <DueoutDetails
                PRP={PRP}
                Priority={Priority}
                dueoutInputs={dueoutInputs}
                existingDueout={existingDueout}
                filesProps={{ files, setFiles }}
                setDueoutInputs={setDueoutInputs}
                updateDueoutInput={updateDueoutInput}
                validationFields={validationFields}
              />
            </div>
          </div>

          {showBottomSubmit && validationMsg.length > 0 && (
            <div>
              <DueoutsFormValidationMsgs
                displayPII={displayPII}
                inputValidationObj={validationMsg}
                piiScan={piiScan}
                popupCloseOpenFunctionality={popupCloseOpenFunctionality}
                ref={closeRef}
                setPIIScan={setPIIScan}
                updateClickPosition='bottom'
                validationref={popupBtnRef}
              />
            </div>
          )}
        </div>
      </div>
      <div className='formheader d-flex px-3 py-1 whitebg shadow5 mt-3 bottom-buttons'>
        <div className='ms-auto formbuttons'>
          <CreateActionBtns
            activeButton={activeButton}
            handleSaveOrSubmit={() => saveOrSubmitDueout('', 'bottom', WHEN_TO_CHECK_PII)}
            handleUpdate={handleUpdate}
            isEditDueout={
              existingDueout && existingDueout.StatusCode !== DUEOUTS_STATUS.SAVED ? true : false
            }
            onClose={onClose}
            onSaveAsDraft={() => onSaveAsDraft('bottom')}
            onSubmit={(event) => {
              event?.preventDefault()
            }}
            showSubmit={showTopSubmit}
            type={'button'}
          />
        </div>
      </div>
      {displayAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={alertMessage}
          onClick={() => {
            setAlertMessage('')
            setDisplayAlert(false)
          }}
          yes='OK'
        />
      )}
      {showSubmitSuccess && (
        <SuccessMessage submissionType='Due Out Form' successType={successType} />
      )}
      {showUpdateProfileAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='No'
          className='alert-info'
          message={`${uniqueChange} Do you want to update profile details?`}
          onClick={profileUpdate}
          yes='Yes'
        />
      )}
      {showCloseAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={'Are you sure you want to close this page?'}
          onClick={closeFunction}
          yes='OK'
        />
      )}
      {showNoChanges && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={'No Changes Detected'}
          onClick={noChangesAlert}
          yes='OK'
        />
      )}
      {showSaveSuccess && (
        <SuccessMessage submissionType='Due Out Form' successType={successType} />
      )}
      {(showPageOverlay || dueoutsAreLoading) && <PageOverlayBusy />}
    </>
  )
}
export default forwardRef(DueoutForm)
export interface DueoutInputs {
  AssignedComponentCode: number
  CategoryCode: null | number
  CustomerId: string
  CustomerStatus: string
  DOS: Date | string
  Description: any
  DescriptionText?: string
  DoDNumber: string
  DueDate: Date | string
  DutyEmail: string
  DutyPhone: string
  IsValidDutyEmail: boolean
  IsValidLocation: boolean
  IsValidOrganization: boolean
  IsValidPASCODE: boolean
  Location: string
  OrgMAJCOM: string
  Organization: string
  PASCODE: string
  PDD: Date | string
  PRP: string
  PersonalEmail?: string
  PersonalPhone?: string
  PersonalPhoneProvider?: string
  Priority: string
  RNLTD: Date | string
  Rank: string
  SectionCode: null | number
  ServicingBy?: string
  ServicingMajcom?: string
  ServicingMajcomCode?: number
  ServicingOrganization?: string
  SubCategoryCode: null | number
  Title: string
}
export interface ValidationFields {
  Category: ValidationMsg
  CurrentDate: ValidationMsg
  DOS: ValidationMsg
  Description: ValidationMsg
  DoDIDNumber: ValidationMsg
  DueDate: ValidationMsg
  DutyEmail: ValidationMsg
  DutyPhone: ValidationMsg
  Location: ValidationMsg
  Organization: ValidationMsg
  PASCODE: ValidationMsg
  PDD: ValidationMsg
  PRP: ValidationMsg
  PersonalMail: ValidationMsg
  PersonalPhone: ValidationMsg
  Priority: ValidationMsg
  RNTD: ValidationMsg
  Rank: ValidationMsg
  Section: ValidationMsg
  Status: ValidationMsg
  Title: ValidationMsg
}
export interface CustomerOrgDetails {
  AssignedComponentCode?: number
  CustomerStatus?: string
  DoDNumber: string
  DutyEmail: string
  DutyPhone?: string
  Location?: string
  OrgMAJCOM?: string
  Organization?: string
  PASCODE?: string
  PascodeID: number
  PersonalEmail?: string
  PersonalPhone?: string
  PersonalPhoneProvider?: string
  Rank?: string
  ServicingBy?: string
  ServicingMajcom?: string
  ServicingMajcomCode?: number
  ServicingOrganization?: string
  UserDisplayName?: string
  UserRID?: string
  eKey?: string
  eTag?: string
}
